import React, { useContext } from 'react'
import { ThemeContext } from './ThemeContext'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Select, { components } from 'react-select'
import Typography from './Typography'

function Dropdown(props) {
  const { theme } = useContext(ThemeContext)
  const {
    id,
    name,
    selected,
    setSelected,
    items,
    inputLabel,
    Icon = ArrowDropDownIcon,
    title,
    source,
    style,
    ...rest
  } = props
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <Icon style={{ width: 55, height: 55, margin: -20, paddingRight: 5 }} />
      </components.DropdownIndicator>
    )
  }
  return (
    <div
      style={{
        ...theme?.dropDown?.container,
        ...theme?.dropDown?.[source]?.container,
        ...style?.container,
      }}
    >
      {title ? (
        <Typography {...props} source={'inputLabel'}>
          {title}
        </Typography>
      ) : (
        <></>
      )}
      <Select
        {...rest}
        // defaultValue={}
        styles={{
          ...theme?.dropDown?.select,
          ...theme?.dropDown?.[source]?.select,
          ...style?.select,
        }}
        unstyled
        name="colors"
        options={items}
        className="basic-multi-select"
        classNamePrefix="select"
        value={selected}
        onChange={setSelected}
        components={{ DropdownIndicator }}
        noOptionsMessage={() => ''}
      />
    </div>
  )
}

export default Dropdown

// for custom styling of react-select see https://react-select.com/styles
